// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pp0xb","colMin":"styles_colMin__2AKgg"};